import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import TkOutSourcingInputInspectionInputDialog from "../dialogTypes/TkOutSourcingInputInspectionInputDialog";

function TkOutSourcingInputInspectionInputButton(props) {
    const { id, schema, grid, refresh, onSuccess, onFailure, customizeErrorMsgCallback, ...others } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [formData, setFormData] = useState();

    useEffect(() => {
        let modifiedSchema = cloneDeep(schema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        column.hideInForm = false;

                        break;

                    default:
                        column.disabled = true;
                        column.required = false;
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const onOpen = () => {
        if (grid && modifiedSchema) {
            let defaultWareHouseCode;

            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        defaultWareHouseCode = column.defaultValue;
                        break;

                    default:
                        break;
                }
            }

            setFormData({
                ...grid.selectedItems[0],
                wareHouseCode: defaultWareHouseCode,
            });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onInputSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <React.Fragment>
            <ActionButtonLayout onClick={onOpen} {...others}>
                {t("buttonName.input")}
            </ActionButtonLayout>
            <TkOutSourcingInputInspectionInputDialog
                id={id + "input-dialog"}
                formId={id + "input-form"}
                title={schema ? t(`dialog.title.${schema.name}.input`) : ""}
                schema={modifiedSchema}
                modifyUrlCallback={(url) => `${url}/doInput`}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onInputSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </React.Fragment>
    );
}

export default TkOutSourcingInputInspectionInputButton;
